import React from "react";
import ClientListShell from "../Shell/ClientListShell.jsx";
import FloatingSupportButton from "../../../components/FloatingSupportButton.jsx";

export default function AgentClientList() {
	// Agents have no Settings › Data Export, so their own cutoff export lives on this page.
	return <ClientListShell canExport footerSlot={<FloatingSupportButton />} emptyText={"No policy found"} />;
}
